const FormResources = {

    rooms_form_data:{
        building_id:        '',
        level_id:           '',
        area_id:            '',
        description:        '',
        task_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        closed:               '',
        door_number:        '',

        fixture_simbol:     1,
        fixtures:           '',

        sq_ft_simbol:       1,
        sq_ft:              '',

        essential_cleaning: '',
        work_group:         '',
        exclude_daily:      '',
        exclude_project:    '',
        patient:            '',

        freq_simbol:        1,
        frequency:          '',

        notes:              '',
        disabled_daily:     '',
        disabled_project:   '',
        daily_assignment_id: '',

        radio:              'all',


        time_adjustment_simbol:       1,
        time_adjustment:              '',

        shift1:             false,
        shift2:             false,
        shift3:             false,
        none:               false,
    },

    room_tasks_form_data:{
        building_id:        '',
        level_id:           '',
        area_id:            '',
        description:        '',
        task_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        closed:               '',
        door_number:        '',

        fixture_simbol:     1,
        fixtures:           '',

        sq_ft_simbol:       1,
        sq_ft:              '',

        essential_cleaning: '',
        work_group:         '',
        exclude_daily:      '',
        exclude_project:    '',
        patient:            '',

        freq_simbol:        1,
        frequency:          '',
        frequency_id:       '',

        notes:              '',
        disabled_daily:     '',
        disabled_project:   '',

        radio:              'all',


        time_adjustment_simbol:       1,
        time_adjustment:              '',

        shift1:             false,
        shift2:             false,
        shift3:             false,
        none:               false,
    },

    buildings_form_data: 
    {
        name: '',
        abbreviation: '',
        level_counter: '',
        level_counter_simbol: 1,
        area_counter: '',
        area_counter_simbol: 1,
        room_counter: '',
        room_counter_simbol: 1,
        sq_footage: '',
        sq_footage_simbol: 1
    },

    levels_form_data: 
    {
        name: '',
        abbreviation: '',
        building_id: '',
        area_counter: '',
        area_counter_simbol: 1,
        room_counter: '',
        room_counter_simbol: 1,
        sq_footage: '',
        sq_footage_simbol: 1
    },

    areas_form_data: 
    {
        name: '',
        abbreviation: '',
        building_id: '',
        level_id: '',
        room_counter: '',
        room_counter_simbol: 1,
        sq_footage: '',
        sq_footage_simbol: 1
    },

    cost_centers_form_data: 
    {
        name: '',
        cost_center: '',
        director_first_name: '',
        director_last_name: '',
        director_ext: '',
        room_counter: '',
        room_counter_simbol: 1,
    },

    cost_center_departments_form_data: 
    {
        name: '',
        cost_center_id: '',
        associate_counter: '',
        associate_counter_simbol: 1,
        personnel_counter: '',
        personnel_counter_simbol: 1
    },

    cost_center_personnel_form_data: 
    {
        name: '',
        last_name: '',
        email: '',
        cost_center_id: '',
        cost_center_department_id: '',
        ext: '',
    },

    room_types_form_data: 
    {
        description: '',
        abbreviation: '',
        floor_id: '',
        housekeeper: '',
        patient: '',
        room_counter: '',
        room_counter_simbol: 1,
        unit: '',
        unit_simbol: 1
    },

    associates_form_data: {
        full_name: '',
        email: '',
        phone1: '',
        phone2: '',
        country_id: '',
        state: '',
        city: '',
        zip_code: '',
        address1: '',
        address2: '',
        role_id: '',
        reports_to: '',
        permissions_template_id: '',
        status_id: '',
        contact_type_id: '',
        department_id: '',
    },

    positions_form_data: {
        name: '',
        description: '',
        group_id: '',
        start_salary: '',
        start_salary_simbol: 1,
        end_salary: '',
        end_salary_simbol: 1,
    },

    contact_types_form_data: {
        description: '',
        include_days_off: '',
        include_assignment: '',
        include_census: '',
        include_qc: '',
        associate_counter: '',
        associate_counter_simbol: 1,
    },

    daily_assignments_form_data: {
        assignment_number: '',
        description: '',
        days_per_week: '',
        days_per_week_simbol: 1,
        minutes: '',
        minutes_simbol: 1,
        avg_time: '',
        avg_time_simbol: 1,
        total_minutes: '',
        total_minutes_simbol: 1,
        total_shift_work_time: '',
        total_shift_work_time_simbol: 1,
        census: '',
        shift_id: '',
        group_id: '',
        cost_center_department_id: '',
        associate_id: '',
        associate_pager: '',
        supervisor_associate_id: '',
        supervisor_pager: '',
    },

    shifts_form_data: 
    {
        number: '',
        description: '',
        class_id: '',
        prep_minutes: '',
        prep_minutes_simbol: 1,
        clenaup_minutes: '',
        clenaup_minutes_simbol: 1,
        total_minutes: '',
        total_minutes_simbol: 1,
        work_time: '',
        work_time_simbol: 1,
        break_counter: '',
        break_counter_simbol: 1,
        
    },

    breaks_form_data: {
        number: '',
        description: '',
        shift_id: '',
        length: '',
        length_simbol: 1,
        paid: '',
    },

    tasks_form_data:
    {
        name: '',
        description: '',
        task_id: '',
        production_standard: '',
        production_standard_simbol: 1,
        unit: '',
    },

    projects_form_data: {
        number: '',
        description: '',
        notes: '',
        associate_id: '',
        show_minutes: '',
        total_minutes: '',
        total_minutes_simbol: 1,
    },

    service_requests_form_data: {
        description: '',
        requestor_name: '',
        requestor_email: '',
        requestor_phone: '',
    },

    staffing_scenarios_form_data: {
        scenario: '',
        fte_hours: '',
        fte_hours_simbol: 1,
        budgeted_ftes: '',
        budgeted_ftes_simbol: 1,
        benefits: '',
        benefits_simbol: 1,
        nonproductive: '',
        nonproductive_simbol: 1,
        paid_break_minutes: '',
        paid_break_minutes_simbol: 1,
        management_team: '',
        management_team_simbol: 1,
        average_wage: '',
        average_wage_simbol: 1,
        total_salary_compensation: '',
        total_salary_compensation_simbol: 1,
    },

    beds_form_data: 
    {
        room: '',
        name: '',
    },

    log_productivities_form_data: 
    {
        daily_assignment_id: '',
        associate_id: '',
        include_productivity: '',
    },

    rotation_templates_form_data:
    {
        description: '',
        day_id: '',
        days_id: '',
        shift_id: '',
        total_templates: '',
        total_templates_simbol: 1,
        total_schedules: '',
        total_schedules_simbol: 1,
    },

    inspection_templates_form_data: {
        name: '',
        description: '',
        instruction: '',
        total_items: '',
        total_items_simbol: 1,
        total_room_types: '',
        total_room_types_simbol: 1,
        total_template_inspections: '',
        total_template_inspections_simbol: 1,
        total_instant_inspections: '',
        total_instant_inspections_simbol: 1,
    },

    template_inspections_form_data: {
        title: '',
        status: '',
        manager_comment: '',
        room_type_id: '',
        inspection_template_id: '',
        associate_id: '',
        associate_employee_id: '',
        total_rooms: '',
        total_rooms_simbol: 1,
    },

    instant_inspections_form_data: {
        title: '',
        status: '',
        manager_comment: '',
        inspection_template_id: '',
        associate_id: '',
        associate_employee_id: '',
        room: ''
    },

    inspection_items_form_data: {
        name: '',
        description: '',
        total_room_types: '',
        total_room_types_simbol: 1,
    },

    surveys_form_data: {
        name: '',
        note: '',
        subject: '',
        email_body: '',
        total_questions: '',
        total_questions_simbol: 1
    },

    step_codes_form_data: {
        name: '',
        code: '',
        memo: '',
    },

    vacant_beds_adjustment_form_data: {
        room_usage: '',
        vacant_bed: '',
        vacant_bed_simbol: 1,
    },

    floor_types_form_data: {
        name: '',
        total_tasks: '',
        total_tasks_simbol: 1,
    },

    time_off_form_data: {
        description: '',
    }

}

export default FormResources